import { colors } from '../../../colors'
import check from '../../../images/check.png'

const styles: Record<string, React.CSSProperties> = {
  successContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '40px 16px',
    textAlign: 'center',
  },
  successTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: colors['text-default'],
    marginBottom: '8px',
  },
  check: {
    width: '128px',
    height: '128px',
    margin: '24px 0px',
  },
  resultDisplayStartText: {
    fontSize: '20px',
    color: colors['keijiban-coral'],
    marginBottom: '16px',
    fontWeight: 'bold',
  },
  resultDisplayStartDatetime: {
    fontSize: '20px',
    color: colors['keijiban-coral'],
  },
  successMessage: {
    fontSize: '12px',
    color: colors['text-secondary'],
    marginBottom: '32px',
    lineHeight: '1.5',
    textAlign: 'left',
  },
  actionButton: {
    padding: '16px 32px',
    backgroundColor: colors.primary,
    color: colors.white,
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    width: '90%',
    position: 'fixed',
    bottom: '16px',
  },
}

const PostSuccess = () => {
  const handleGoToPostList = () => {
    window.location.href = '/message_board'
  }

  return (
    <div style={styles.successContainer}>
      <h2 style={styles.successTitle}>投稿ありがとうございました</h2>

      <img src={check} style={styles.check} alt="check" />

      <div style={styles.resultDisplayStartText}>公開までしばらくお待ちください</div>

      <p style={styles.successMessage}>
        ※公開までおよそ1日〜数日程度要する場合があります
        <br />
        ※投稿内容が投稿ガイドラインに違反していた場合、運営側で投稿を非公開とさせていただく場合があります。あらかじめご了承ください。
      </p>

      <button type="button" onClick={handleGoToPostList} style={styles.actionButton}>
        口コミ一覧
      </button>
    </div>
  )
}

export default PostSuccess
